function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Grabs cookie attribute from document and converts to JSON
 * @return {Object}
 */
export function getCookies() {
  if (typeof document === 'undefined') return {};
  if (!document.cookie) return {};
  return document.cookie.split('; ').reduce(function (memo, cookie) {
    var _cookie$split = cookie.split('='),
        _cookie$split2 = _slicedToArray(_cookie$split, 2),
        key = _cookie$split2[0],
        value = _cookie$split2[1];

    memo[key] = value;
    return memo;
  }, {});
}